export const adjectives = [
  // 1. Funksioni
  {
    id: 'adj-attribut',
    category: 'adjektive',
    level: 'A2',
    title: 'Adjektiv als Attribut (Mbiemri si Atribut)',
    detailedContent: `
      <section>
        <p>Mbiemri luan rolin e Atributit ("Mbiemri Përcaktor") kur ai vendoset <b>drejtpërdrejt PËRPARA</b> emrit që po përshkruan.</p>
        
        <h3>1. Karakteristika Kryesore: Deklinimi</h3>
        <p>Ndryshe nga gjuha shqipe a angleze, në gjermanisht kur mbiemri del PËRPARA emrit, ai duhet thjeshtë t'i VISHET / LAKOHET me një format fundor sipas gjinisë, numrit, dhe rastit të atij emri (Deklination).</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli:</strong> [Nyje] + [Mbiemër <b>+ mbaresë</b>] + [Emër]
        </div>
        
        <h3>2. Shembuj formimi:</h3>
        <ul>
          <li>der <b>gute</b> Wein (vera E mirë).</li>
          <li>ein <b>schnelles</b> Auto (një makinë E shpejtë).</li>
          <li>mit meiner <b>neuen</b> Freundin (me të dashurën time TË re).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Das ist ein schönes Haus.', alb: 'Kjo është një shtëpi E bukur. (schön -> schönes)' }
    ],
    exercises: []
  },
  {
    id: 'adj-praedikat',
    category: 'adjektive',
    level: 'A1',
    title: 'Adjektiv als Prädikat (Mbiemri si Kallëzues)',
    detailedContent: `
      <section>
        <p>Kur mbiemri shfaqet <b>PAS</b> foljeve thelbësore (zakonisht: <i>sein, werden, bleiben, wirken, aussehen</i>), atëherë ai konsiderohet Pjesë Kallëzuesore (Prädikativ).</p>

        <h3>Rregulli i Artë!</h3>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>NUK DEKLINOHET KURRË!</strong> Mbiemri mbetet tamam siç e gjeni falas në fjalor, pa ia prekur ASNJË gërmë apo mbaresë fundore, pavarësisht nëse emri është njerëz, femër, ose 100 njerëz shumës.
        </div>
        
        <ul>
          <li>Der Mann ist <b>groß</b>. (Burri është i gjatë)</li>
          <li>Die Männer sind <b>groß</b>. (Burrat janë të gjatë - "groß" mbetet identik pa ndryshuar asgjë!)</li>
          <li>Das Auto bleibt <b>teuer</b>. (Makina mbetet e shtrenjtë).</li>
        </ul>
      </section>
    `,
    exercises: [
      { question: 'Pse nuk themi "Die Frauen sind schönes"?', options: ['Sepse schönes është mashkullor', 'Sepse në pozicion mbas foljes (si prädikat), mbiemri NUK dekinohet e NUK merr mbaresa', 'Sepse gratë skan nyje'], correct: 1, explanation: 'Mbiemri merr mbaresë VETËM nëse gjendet FIKS PËRPARA emrit të vet.' }
    ]
  },

  // 2. Deklinimi
  {
    id: 'adj-dek-bestimmt',
    category: 'adjektive',
    level: 'A2',
    title: 'Adjektivdeklination: Bestimmter Artikel (LAKIMI I DOBËT)',
    detailedContent: `
      <section>
        <p>Ky është lakimi me Nyjet e Shquara: <b>der, die, das, die (pl)</b>. Njihet si "Lakimi i Dobët" i mbiemrit sepse vetë fjala "der/die/das" e tregon aq qartë gjininë, saqë mbiemri ska nevoj mbajn ngarkesën gramatikore thelbesisht ! - prandaj mbaresat e mbiemrit jan të "dobëta" (vetëm <b>-e</b> ose <b>-en</b>).</p>
        
        <h3>Rregulli i "Tiganit":</h3>
        <p>Imagjinoni formën e një tigani në tabelën e deklinimit:</p>
        <ul>
          <li><b>Në Nominativ:</b> der/die/das mbajnë <b>"-e"</b> fundore te mbiemri. (der gut<b>e</b>, die gut<b>e</b>, das gut<b>e</b>).</li>
          <li><b>Në Akkusativ <i>Neutral the Feminin</i>:</b> mbeten po njëtrajtazi me <b>"-e"</b> (die gut<b>e</b>, das gut<b>e</b>).</li>
          <li><b>TË GJITHA TË TJERAT NË BOTË:</b> marrin <b>"-en"</b>! Ky është sekreti gjenial i gjuhes. </li>
        </ul>
        <p>Rastet me <b>-en</b> përfshijnë: Çdo gjë në Akkusativ Maskulin, të gjithë Dativët panjashtim, të gjithë Genitivët panjashtim, të gjithë Shumësin panjashtim!</p>
      </section>
    `,
    tables: [
      {
        label: 'Tabela: Nyje e Shquar (der, die, das)',
        headers: ['Kasus', 'Maskulin', 'Feminin', 'Neutral', 'Plural'],
        rows: [
          ['Nominativ (Kush?)', 'der alt<b>e</b> Mann', 'die alt<b>e</b> Frau', 'das alt<b>e</b> Auto', 'die alt<b>en</b> Kinder'],
          ['Akkusativ (Kë?)', 'den alt<b>en</b> Mann', 'die alt<b>e</b> Frau', 'das alt<b>e</b> Auto', 'die alt<b>en</b> Kinder'],
          ['Dativ (Kujt?)', 'dem alt<b>en</b> Mann', 'der alt<b>en</b> Frau', 'dem alt<b>en</b> Auto', 'den alt<b>en</b> Kindern'],
          ['Genitiv (I kujt?)', 'des alt<b>en</b> Mannes', 'der alt<b>en</b> Frau', 'des alt<b>en</b> Autos', 'der alt<b>en</b> Kinder']
        ]
      }
    ],
    examples: [
      { ger: 'Ich kaufe das rote Auto.', alb: 'Unë blej makinën e kuqe. (Akkusativ Neutral -> merr "-e" "rote")' },
      { ger: 'Ich helfe dem alten Mann.', alb: 'Unë e ndihmoj burrin e moshuar. (Dativ -> të gjithë mbiemrat marrin "-en" !)' }
    ],
    exercises: []
  },
  {
    id: 'adj-dek-unbestimmt',
    category: 'adjektive',
    level: 'A2',
    title: 'Adjektivdeklination: Unbestimmter Artikel (LAKIMI I PËRZIER)',
    detailedContent: `
      <section>
        <p>Bëhet fjalë për Përdorimin e mbiemrit pas Nyjeve të Pashquara <b>(ein, eine, ein)</b> ose Nyjeve Pronore <b>(mein, dein, sein...)</b> dhe nyjës Mohuese <b>(kein)</b>. Njihet si Lakimi i Përzier.</p>

        <h3>Pse është i përzier?</h3>
        <p>Sepse fjala "ein" ose "mein" (Për Maskulin Nominativ, dhe Neutral Nominativ + Akkusativ), <b>NUK E TREGON MJAFTUESHËM GJININË</b>! (Prsh "ein" mund të jetë edhe djal (ein Mann) edhe makine (ein Auto)).</p>
        <p>Prandaj, pesha gramatikore BI TEK MBIEMRI ! Mbiemri MER Prapashtesën që do kishte pasur Nyja 'der/das/die' origjinale.</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Regulli Kyç:</strong> Kur "ein/mein" nuk ka prapashtesë, MBIEMRI MERR GJININË. Përndryshe, mbetet si rregulli i "tiganit".
        </div>

        <ul>
          <li>ein Mann = ein gut<b>er</b> Mann (Sepse "er" vjen thellësisht nga d<b>er</b>)</li>
          <li>ein Auto = ein schnell<b>es</b> Auto (Sepse Auto është d<b>as</b>).</li>
          <li>eine Frau = eine schön<b>e</b> Frau.</li>
        </ul>
        <p>Ndërsa në të GJITHA RASTET e tjera lakuese zhdrejta (Akk maskulin, të gjithë Dativ & Genitiv dhe i gjithë Shumësi), i kthehemi rregullit normal ku ata bien nën peshë dhe thjesht i fusin një <b>"-en"</b> mbrapa !</p>
      </section>
    `,
    tables: [
      {
        label: 'Tabela: Nyje e Pashquar (ein, eine, mein, kein)',
        headers: ['Kasus', 'Maskulin', 'Feminin', 'Neutral', 'Plural (keine)'],
        rows: [
          ['Nominativ', 'ein rot<b>er</b> Apfel', 'eine rot<b>e</b> Blume', 'ein rot<b>es</b> Buch', 'keine rot<b>en</b> Äpfel'],
          ['Akkusativ', 'einen rot<b>en</b> Apfel', 'eine rot<b>e</b> Blume', 'ein rot<b>es</b> Buch', 'keine rot<b>en</b> Äpfel'],
          ['Dativ', 'einem rot<b>en</b> Apfel', 'einer rot<b>en</b> Blume', 'einem rot<b>en</b> Buch', 'keinen rot<b>en</b> Äpfeln']
        ]
      }
    ],
    examples: [],
    exercises: [
      { question: 'Plotësoni: "Das ist ein nett___ Hund" (Hund eshte der).', options: ['en', 'e', 'er'], correct: 2, explanation: '"ein" për der Hund në Nominativ nuk ka tregues. Ndaj thelin e mbart mbiemri "netter".' }
    ]
  },
  {
    id: 'adj-dek-ohne',
    category: 'adjektive',
    level: 'B1',
    title: 'Adjektivdeklination: Ohne Artikel (LAKIMI I FORTË)',
    detailedContent: `
      <section>
        <p>Lakimi i Fortë ndodh kur emri dhe mbiemri <b>NUK KANË ASNJË NYJE PAPRA VETES</b> (zero artikel / Nullartikel). Kjo ndodh rëndom me Lëndët, Kualitetet, Numrin Shumës abstrakt, apo Ndjenjat.</p>

        <h3>Rregulli i Artë i të Fortëve:</h3>
        <p>Meqënse ska asnjë der/die/das... për të treguar gjininë dhe rastin, <b>I THELLË NË PESHE HY TASHMË 100% VETËM MBIEMRI</b>.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli:</strong> Mbaresa që përbën Mbiemri është FIKS NJËLAJTË ME MBARESËN e nyjës që duhet të kishte qenë aty (der, die, das, dem, den).
        </div>

        <ul>
          <li>Maskulin Nominativ: Wein (d<b>er</b>) -> kalt<b>er</b> Wein.</li>
          <li>Neutral Akkusativ: Wasser (d<b>as</b>) -> kalt<b>es</b> Wasser.</li>
          <li>Feminin Dativ: Milch (d<b>er</b> f.) -> mit kalt<b>er</b> Milch.</li>
          <li>Plural Dativ: Leuten (d<b>en</b>) -> von neu<b>en</b> Leuten.</li>
        </ul>
        <p><i>Kujdes-Përjashtim i Vogël! Në Genitiv Mashkull/Asnjanës, mbiemri merr "-en" në vend të "-es" sepse vetë emri në Genitiv ka marrë "-s"-në formale nga mbas! P.sh (kalt<b>en</b> Wassers).</i></p>
      </section>
    `,
    tables: [
      {
        label: 'Tabela: Lakimi Pa Nyje',
        headers: ['Kasus', 'Maskulin', 'Feminin', 'Neutral', 'Plural'],
        rows: [
          ['Nominativ', 'kalt<b>er</b> Wein', 'kalt<b>e</b> Milch', 'kalt<b>es</b> Wasser', 'kalt<b>e</b> Nächte'],
          ['Akkusativ', 'kalt<b>en</b> Wein', 'kalt<b>e</b> Milch', 'kalt<b>es</b> Wasser', 'kalt<b>e</b> Nächte'],
          ['Dativ', 'kalt<b>em</b> Wein', 'kalt<b>er</b> Milch', 'kalt<b>em</b> Wasser', 'kalt<b>en</b> Nächten'],
          ['Genitiv', 'kalt<b>en</b> Weins', 'kalt<b>er</b> Milch', 'kalt<b>en</b> Wassers', 'kalt<b>er</b> Nächte']
        ]
      }
    ],
    examples: [],
    exercises: []
  },

  // 3. Krahasimi
  {
    id: 'positiiv',
    category: 'adjektive',
    level: 'A2',
    title: 'Positiv (Shkalla BAZË - Barazia)',
    detailedContent: `
      <section>
        <p>Shkalla bazike, fiks kuptimi normal i fjalorit. Kur duam TË KRAHASOJMË dy cilësi që TË DYA JANË TË BARABARTA (ose të ndryshme thelbësisht mohore). </p>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli për formim krahasimor:</strong> <b>so [MBIEMRI BAZË] wie</b> (aq ... sa) / <b>genauso ... wie</b>
        </div>

        <ul>
          <li><i>Peter ist <b>genauso groß wie</b> Hans.</i> (Piteri është FIKS AQ I GJATË SA Hansi).</li>
          <li><i>Lisa ist <b>nicht so schnell wie</b> Anna.</i> (Lisa nuk është aq e shpejte sa).</li>
        </ul>
      </section>
    `,
    exercises: []
  },
  {
    id: 'komparativ',
    category: 'adjektive',
    level: 'B1',
    title: 'Komparativ (Shkalla Krahasore)',
    detailedContent: `
      <section>
        <p>Komparativ rrit sasinë absolute ose thelbin cilsues krahasuar me dikë/diçka tjetër.</p>

        <h3>1. Si formohet Rregullisht?</h3>
        <p>Thjesht i bashkëngjitet një prapashtesë <b>"-er"</b> mbiemrit në fund, dhe shpesh vihet thelbi krahasimor <b>"als"</b> (sesa).</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Mbiemër + er ... als</strong>
        </div>
        <ul>
          <li>schnell (i shpejtë) -> schnell<b>er</b> (më i shpejtë). <i>Ein Flugzeug ist schneller als ein Auto.</i></li>
          <li>klein (i vogël) -> klein<b>er</b>. <i>Meine Wohnung ist kleiner als deine.</i></li>
        </ul>

        <h3>2. Shumë mbiemra me vetëm 1 rrokje marrin Umlaut</h3>
        <p>Fjalët thelbesishte të vjetra, të thata dhe theksuese e rrokshe:</p>
        <ul>
          <li>groß (i madh) -> <b>gRÖßer</b>. (Jo groser).</li>
          <li>alt (i vjetër) -> <b>älter</b>.</li>
          <li>kalt (i ftohtë) -> <b>kälter</b>.</li>
          <li>jung (i ri) -> <b>jünger</b>.</li>
        </ul>

        <h3>3. E Parregullt (Unregelmäßig)</h3>
        <ul>
          <li>gut -> <b>besser</b> (jo "guter")</li>
          <li>viel -> <b>mehr</b></li>
          <li>gern -> <b>lieber</b></li>
          <li>hoch -> <b>höher</b> (Kujdes: Ikën "c"-ja). </li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: [
      { question: 'Si shkruhet e kundërta "Marku është i pasur, por Ema është *më e pasur*"? reich -> ...', options: ['reicher', 'reichter', 'räicher (Umlaut)'], correct: 0, explanation: 'Reich nuk merr umlaut dhe thjesht shton "-er" (më i pasur).' }
    ]
  },
  {
    id: 'superlativ',
    category: 'adjektive',
    level: 'B1',
    title: 'Superlativ (Shkalla Sipërore)',
    detailedContent: `
      <section>
        <p>Tregon statusin absolut - asgjë nuk mund ta kalojë! Është niveli thelbësor absolut! "Më i madhi, më i miri, më i ashpri!".</p>

        <h3>1. Forma Pa Emër Mbrapa (Prädikativ)</h3>
        <p>Nëse fjala thuhet pa dert tjetër n fund t fjalisë përdoret thelbi absolutisht e mrekllë: <b>am + _____ + -sten</b>.</p>
        <ul>
          <li>schnell -> <b>am schnellsten</b>. (Der Gepard läuft am schnellsten - Geopardi gjuan/vrapon më së shpejti n botë).</li>
          <li>klein -> <b>am kleinsten</b>. (Mei Auto ist am kleinsten - Makina jem asht me e vogla).</li>
        </ul>

        <h3>2. Forma ME Emër Përpara (Attributiv)</h3>
        <p>Nëse themi "Tavolina MË e Gjatë" , "Ndeshja MË e bukur". Këtu kthehemi URGJENT tek Rregullat e Deklinimit (shih nalt)! Dhe thelbi "Super" jiphet me fjalen thelbsore -st- ne zemer.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Nyja E Shquar + mbiemër + st + mbaresë + EMRI.</strong>
        </div>
        <p><i>Das <b>schnellste</b> Auto der Welt.</i> (Makina më E shpejte). Akkusativ: <i>Er kauft den <b>teuersten</b> Ring (Unaza MË E SHTRENJTË).</i></p>

        <h3>3. Me umlaut ashtu si tek komparativ!</h3>
        <ul>
          <li>groß -> <b>am größten</b> / das <b>größte</b> Haus.</li>
          <li>alt -> <b>am ältesten</b> (Kujdes! Meqe mbaron me Mbyllse T, merr nji e! -> altesten gabim. Ält<b>e</b>sten Sakte)</li>
        </ul>

        <h3>4. Super të Parregulltat</h3>
        <ul>
          <li><b>gut -> besser -> am besten / das beste</b></li>
          <li><b>viel -> mehr -> am meisten / die meisten</b> (Kujdes! Ndryshon totalisht rrenja ne 'meist').</li>
          <li><b>gern -> lieber -> am liebsten</b></li>
          <li><b>hoch -> höher -> am höchsten</b></li>
        </ul>
      </section>
    `,
    tables: [
      {
        label: 'Treqshia e pafund e ngritjes (Steigerung)',
        headers: ['Positiv', 'Komparativ', 'Superlativ'],
        rows: [
          ['schnell (shpejt)', 'schneller (më sh)', 'am schnellsten (më së shpetji)'],
          ['groß (madh)', 'größer (me m)', 'am größten (më së math)'],
          ['gut (mirë)', 'besser (m. mire)', 'am besten (më se miri)'],
          ['viel (shumë)', 'mehr (më shoume)', 'am meisten (mbi shumsia absolute)'],
          ['gern (me kenaqs)', 'lieber', 'am liebsten']
        ]
      }
    ],
    examples: [],
    exercises: []
  }
];
